import PropTypes from 'prop-types';

const ScaleBarChart = ({ value }) => {
	const colorVal = value >= 60 ? 'green' : value >= 40 ? 'warning' : 'danger';
	const highVal = value >= 90;
	return (
		<div className="scale-bar-chart">
			<div className="labels d-flex py-1">
				<div className="flex-fill text-center">Very Low</div>
				<div className="flex-fill text-center">Low</div>
				<div className="flex-fill text-center">Medium</div>
				<div className="flex-fill text-center">High</div>
				<div className="flex-fill text-center">Very High</div>
			</div>
			<div className="scale-bar rounded-2 bg-eqqo-light-gray overflow-hidden position-relative">
				<div
					className={`scale-bar-fill py-4 bg-${colorVal}`}
					style={{ width: `${value}%` }}
				/>
				<div
					className={`scale-bar-value position-absolute text-${highVal ? 'white' : colorVal}`}
					style={{
						left: highVal ? `calc(${value}% - 1em)` : `calc(${value}% + 1em)`,
						top: "50%",
						transform: 'translateX(-50%) translateY(-50%) rotate(90deg)',
						transformOrigin: 'center'
					}}
				>
					{value?.toFixed(2)}%
				</div>
				<div className="ticks d-flex position-absolute" style={{ bottom: '0', left: '0', right: '0', top: '0' }}>
					<div className="tick flex-fill border-right" />
					<div className="tick flex-fill border-right" />
					<div className="tick flex-fill border-right" />
					<div className="tick flex-fill border-right" />
					<div className="tick flex-fill" />
				</div>
			</div>
		</div>
	);
}

ScaleBarChart.propTypes = {
	value: PropTypes.number.isRequired,
};

export default ScaleBarChart;